export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8911.b1aabc29.jpg";